import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import { newChoiceObject } from '../../Entries';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { TextField, MenuItem } from '@material-ui/core';
import clsx from 'clsx';
import OutlinedSelect from '../../../controls/OutlinedSelect';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ChoicesFromApi from './Choices/ChoicesFromApi';

const styles = (theme) => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
        fontSize: 14,
    },
    draggableChoice: {
        margin: theme.spacing(0, -3),
        padding: theme.spacing(0.5, 3, 1, 0),
        display: 'flex',
    },
    choice: {
        '&:hover': {
            backgroundColor: 'rgb(189, 189, 189, 0.1)',
        },
        '&:hover $dragIcon': {
            visibility: 'visible',
        },
    },
    choiceIcon: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    choiceTextbox: {
        backgroundColor: 'white',
        marginRight: '5px',
    },
    drag: {
        backgroundColor: 'rgb(189, 189, 189, 0.1)',
        '&:active $dragIcon': {
            visibility: 'visible',
        },
    },
    dragIcon: {
        visibility: 'hidden',
        height: 'auto',
    },
    queryParams: {
        backgroundColor: 'white',
        margin: theme.spacing(0, 2),
        display: 'flex',
    },
    control: {
        backgroundColor: '#ffffff',
        margin: theme.spacing(0, 1),
    },
    applyTextEllipsis: {
        whiteSpace: 'nowrap',
        width: 'calc(100% - 3rem)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    removeTextEllipsis: {
        whiteSpace: 'unset',
        width: 'initial',
        overflow: 'unset',
        textOverflow: 'unset',
    },
    rightMargin: {
        marginRight: '5%',
    },
});

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 40,
        height: 22,
        padding: 2.3,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    disabled: {
        '&$checked': {
            '& + $track': {
                opacity: 0.5,
            },
        },
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 26 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);
const newQueryParamObject = { queryParamType: '', queryParamValue: '' };

class DropdownDetails extends React.Component {
    state = {
        choicesFromApi: false,
        api: {
            url: '',
            queryParamsArray: [newQueryParamObject],
            resultMapping: {
                value: 'id',
                label: 'label',
            },
        },
    };

    onToggleChoicesType = (value) => {
        if (value) {
            if (!this.props.field.api) {
                const target = {
                    id: 'api',
                    value: this.state.api,
                };
                this.props.handleChange({ target });
            }
        } else {
            if (!this.props.field.choices) {
                const target = {
                    id: 'choices',
                    value: [newChoiceObject, newChoiceObject, newChoiceObject],
                };
                this.props.handleChange({ target });
            }
        }
        const target = {
            id: 'choicesFromApi',
            value: value,
        };
        this.props.handleChange({ target });
        this.setState({ choicesFromApi: value });
    };

    componentDidMount() {
        if (this.props.field.api) {
            const target = {
                id: 'choicesFromApi',
                value: true,
            };
            this.props.handleChange({ target });
            this.setState({
                choicesFromApi: true,
                api: {
                    ...this.props.field.api,
                    queryParamsArray: this.formatQueryParamsForApi(
                        this.props.field.api.queryParams ?? this.props.field.api.queryParamsArray,
                    ),
                },
            });
        }
    }

    onApiChange = (event) => {
        let api = { ...this.state.api };
        if (event.id === 'url') {
            api = {
                ...this.state.api,
                url: event.updatedUrl,
            };
        }
        if (event.id === 'resultMappingValue') {
            api = {
                ...this.state.api,
                resultMapping: {
                    ...this.state.api.resultMapping,
                    label: event.resultMappingValue,
                },
            };
        }
        if (event.id === 'queryParams') {
            api = {
                ...this.state.api,
                queryParamsArray: event.updatedQueryParams,
            };
        }

        this.setState({ api: api });
        const target = {
            id: 'api',
            value: api,
        };
        this.props.handleChange({ target });
    };

    handleDeleteChoice = (index) => {
        this.onChoicesChange(index);
    };

    handleChangeChoice = (index, newChoice) => {
        const choiceObject = { label: newChoice, value: newChoice };
        const action = 'change';
        this.onChoicesChange(index, choiceObject, action);
    };

    handleAddChoice = (index) => {
        const action = 'add';
        this.onChoicesChange(index, newChoiceObject, action);
    };

    onChoicesChange = (index, value, action) => {
        const prevEntry = this.props.field;
        let newChoices;
        if (value && action === 'change') {
            newChoices = [...prevEntry.choices.slice(0, index), value, ...prevEntry.choices.slice(index + 1)];
        } else if (value && action === 'add') {
            newChoices = [...prevEntry.choices.slice(0, index + 1), value, ...prevEntry.choices.slice(index + 1)];
        } else {
            if (prevEntry.choices.length === 1) {
                newChoices = [newChoiceObject];
            } else {
                newChoices = prevEntry.choices.filter((choice, choiceIndex) => choiceIndex !== index);
            }
        }
        const target = {
            id: 'choices',
            value: newChoices,
        };
        this.props.handleChange({ target });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        let choices = [...this.props.field.choices];
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }
        const choice = choices[source.index];
        choices.splice(source.index, 1);
        choices.splice(destination.index, 0, choice);
        const target = {
            id: 'choices',
            value: choices,
        };
        this.props.handleChange({ target });
    };

    formatQueryParamsForApi = (queryParamsFromStateOrProps) => {
        if (this.props.field.api) {
            if (Array.isArray(queryParamsFromStateOrProps)) {
                return [...queryParamsFromStateOrProps];
            } else {
                let queryParamsObj = queryParamsFromStateOrProps;
                let queryParams = [];
                for (let index = 0; index < Object.keys(queryParamsObj).length; index++) {
                    let queryParamType = Object.keys(queryParamsObj)[index].substring(
                        14,
                        Object.keys(queryParamsObj)[index].length - 1,
                    );
                    let queryParamValue = Object.values(queryParamsObj)[index];
                    let queryParam = {
                        queryParamType,
                        queryParamValue,
                    };
                    queryParams.push(queryParam);
                }
                if (queryParams.length <= 0) {
                    queryParams.push(newQueryParamObject);
                }
                return [...queryParams];
            }
        }
    };

    render() {
        const choices = this.props.field.choices || [];
        const { classes } = this.props;
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            id="instructions"
                            label="Field Instructions"
                            value={this.props.field.instructions}
                            multiline
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="label"
                            label="Label"
                            value={this.props.field.label}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            className={this.props.classes.whiteBackground}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} container justify="space-between">
                        <Typography className={classes.grey}>Choices</Typography>
                        <FormControlLabel
                            label={<Typography className={classes.grey}>Add Choices with URL</Typography>}
                            labelPlacement="start"
                            control={
                                <AntSwitch
                                    color="primary"
                                    size="small"
                                    checked={this.state.choicesFromApi}
                                    onChange={(e, switchValue) => this.onToggleChoicesType(switchValue)}
                                />
                            }
                        />
                    </Grid>
                    {this.state.choicesFromApi === true ? (
                        <ChoicesFromApi
                            api={this.state.api}
                            formatQueryParamsForApi={this.formatQueryParamsForApi}
                            onApiChange={this.onApiChange}
                            factFields={this.props.factFields}
                        />
                    ) : (
                        <Grid item xs={12}>
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                {choices.length > 0 && (
                                    <Droppable droppableId="choicesDroppable">
                                        {(provided) => (
                                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                                {choices.map((choice, index) => (
                                                    <Draggable
                                                        key={`choice-${index}`}
                                                        draggableId={`${choice.label} ${index}`}
                                                        index={index}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <div
                                                                className={clsx(classes.draggableChoice, {
                                                                    [classes.drag]: snapshot.isDragging,
                                                                    [classes.choice]: !snapshot.isDragging,
                                                                })}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                ref={provided.innerRef}
                                                            >
                                                                <DragIndicatorIcon
                                                                    className={classes.dragIcon}
                                                                    color="action"
                                                                />
                                                                <TextField
                                                                    fullWidth
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    value={choice.label}
                                                                    inputProps={{ 'aria-label': `${choice.label}` }}
                                                                    className={classes.whiteBackground}
                                                                    onChange={(event) =>
                                                                        this.handleChangeChoice(
                                                                            index,
                                                                            event.target.value,
                                                                        )
                                                                    }
                                                                />
                                                                <Tooltip title="Add" aria-label="add choice">
                                                                    <IconButton
                                                                        onClick={() => this.handleAddChoice(index)}
                                                                        size="small"
                                                                        className={classes.choiceIcon}
                                                                    >
                                                                        <AddCircleOutlineIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete" aria-label="delete choice">
                                                                    <IconButton
                                                                        onClick={() => this.handleDeleteChoice(index)}
                                                                        size="small"
                                                                        className={classes.choiceIcon}
                                                                    >
                                                                        <RemoveCircleOutlineIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                )}
                            </DragDropContext>
                            {this.state.choicesFromApi === false && (
                                <Grid item xs={12}>
                                    <OutlinedSelect
                                        id="initialValue"
                                        name="initialValue"
                                        label="Default Answer"
                                        value={this.props.field.initialValue ? this.props.field.initialValue : ''}
                                        onChange={this.props.handleChange}
                                    >
                                        {this.props.field.choices &&
                                            this.props.field.choices.map((choice) => (
                                                <MenuItem key={choice.value} value={choice.value}>
                                                    {choice.label}
                                                </MenuItem>
                                            ))}
                                    </OutlinedSelect>
                                </Grid>
                            )}
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            id="additionalInfo"
                            label="Additional Information"
                            multiline
                            rowsMax={15}
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            rows={4}
                            fullWidth
                            value={this.props.field.additionalInfo}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(DropdownDetails);
